// extracted by mini-css-extract-plugin
module.exports = {"leagueNameWrapper":"TheRoundTitle_leagueNameWrapper_1mxRK","leagueLogo":"TheRoundTitle_leagueLogo_17TbG","nowrap":"TheRoundTitle_nowrap_1pT9B"};